import styled from "styled-components";
import { palette, fonts, radii } from "../../styles/palette";

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: ${palette.overlayDark};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;

  @media (max-width: 480px) {
    padding: 12px;
    align-items: flex-start;
    padding-top: 20px;
  }
`;

export const ModalCard = styled.div`
  background: ${palette.white};
  border: 1px solid ${palette.border};
  border-radius: ${radii.md};
  box-shadow: 0 18px 48px rgba(35, 35, 35, 0.24);
  width: 100%;
  max-width: 480px;
  padding: 32px 32px;
  position: relative;

  @media (max-width: 480px) {
    max-width: 100%;
    padding: 24px 20px;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
  }
`;

export const ModalTitle = styled.h2`
  font-family: ${fonts.heading};
  font-size: 24px;
  font-weight: 600;
  color: ${palette.navy};
  margin: 0 0 20px 0;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 20px;
    margin: 0 0 16px 0;
  }
`;

export const ModalContent = styled.div`
  margin-bottom: 24px;
`;

export const ModalButton = styled.button`
  background: ${palette.red};
  color: ${palette.white};
  border: none;
  border-radius: ${radii.pill};
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s;
  box-shadow: 0 4px 14px ${palette.redGlow};

  &:hover {
    background: ${palette.redHover};
    transform: translateY(-1px);
    box-shadow: 0 6px 18px ${palette.redGlow};
  }

  @media (max-width: 480px) {
    padding: 12px 24px;
    font-size: 15px;
    position: sticky;
    bottom: 0;
    margin-top: 16px;
  }
`;

export const NPSContainer = styled.div`
  margin: 24px 0;
`;

export const NPSQuestion = styled.h3`
  font-family: ${fonts.heading};
  font-size: 18px;
  font-weight: 600;
  color: ${palette.navy};
  margin: 0 0 16px 0;
  text-align: center;
  line-height: 1.4;
`;

export const NPSSubtitle = styled.p`
  font-size: 14px;
  color: ${palette.textSecondary};
  margin: 0 0 20px 0;
  text-align: center;
  line-height: 1.5;
`;

export const NPSRatingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 8px;
`;

export const NPSRatingButton = styled.button<{ selected?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1.5px solid
    ${({ selected }) => (selected ? palette.red : palette.border)};
  background: ${({ selected }) => (selected ? palette.red : palette.white)};
  color: ${({ selected }) => (selected ? palette.white : palette.navy)};
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${({ selected }) =>
    selected ? `0 4px 12px ${palette.redGlow}` : "none"};

  &:hover {
    border-color: ${palette.red};
    color: ${({ selected }) => (selected ? palette.white : palette.red)};
    background: ${({ selected }) =>
      selected ? palette.red : palette.surfaceMuted};
  }
`;

export const NPSLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 12px;
  color: ${palette.textSecondary};
`;

export const NPSCommentArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  border: 1.5px solid ${palette.border};
  border-radius: ${radii.sm};
  padding: 12px;
  font-size: 14px;
  font-family: inherit;
  color: ${palette.black};
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${palette.red};
    box-shadow: 0 0 0 3px ${palette.redGlowSoft};
  }

  &::placeholder {
    color: ${palette.textSecondary};
  }
`;

export const NPSButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

export const NPSSubmitButton = styled.button`
  background: ${palette.red};
  color: ${palette.white};
  border: none;
  border-radius: ${radii.pill};
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  flex: 1;
  transition: all 0.3s;
  box-shadow: 0 4px 14px ${palette.redGlow};

  &:hover {
    background: ${palette.redHover};
    box-shadow: 0 6px 18px ${palette.redGlow};
  }

  &:disabled {
    background: ${palette.gray};
    color: ${palette.textSecondary};
    box-shadow: none;
    cursor: not-allowed;
  }
`;

export const NPSSkipButton = styled.button`
  background: transparent;
  color: ${palette.navy};
  border: 1.5px solid ${palette.border};
  border-radius: ${radii.pill};
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  flex: 1;
  transition: all 0.3s;

  &:hover {
    background: ${palette.surfaceMuted};
    border-color: ${palette.navy};
  }
`;
